import { withAnalytics } from 'components/common/analytics';
import { RadioButton } from 'components/common/button/radio-button';
import { compose } from 'redux';

const enhance = compose(withAnalytics);
const RadioButtonContainer = enhance(RadioButton);

export { RadioButtonContainer };
